import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../environments/environment";

@Injectable()
export class AddCustomHeadersInterceptor implements HttpInterceptor {
  urlsToNotUse: Array<string>;

  constructor(
    private auth: AuthenticationService,
    private srvRoute: ActivatedRoute
  ) {
    this.urlsToNotUse = ["Authenticate/login", "api/par/generales"];
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const apiCredit = environment.apiCredit;

    if (request.url.startsWith(apiCredit)) {
      //  console.log("Interceptando:", request.url);
      const boToken = JSON.parse(localStorage.getItem("boToken") || "null");
      // console.log("Token encontrado:", boToken);
      if (!boToken) {
        return next.handle(request);
      }
      const headers: any = {
        Authorization: `Bearer ${boToken}`
      };

      // Si NO es FormData, agregamos application/json. 
      // Si ES FormData, dejamos que el navegador ponga el Content-Type con el boundary correcto.
      if (!(request.body instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }

      const modifiedRequest = request.clone({
        setHeaders: headers
      });

      return next.handle(modifiedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.auth.logout();
          }
          return throwError(() => error);
        })
      );
    }

    if (this.isValidRequestForInterceptor(request.url)) {
      if (request.url === "http://localhost:51184/api/par/generales2") {
        const modifiedRequest = request.clone({
          setHeaders: {
            "Content-Type": "application/json",
          },
        });

        return next.handle(modifiedRequest).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.auth.logout();
            }

            return throwError(error);
          })
        );
      } else if (
        request.headers.has("Authorization") === true ||
        (request.url.includes("generales") && request.url.includes("par"))
      ) {
        // INICIO IF

        // CAPTURATR EL PUTO TOKEN QUE ME TIENE DE UN HUEVO

        const token = JSON.parse(localStorage.getItem("token"));

        const modifiedRequest = request.clone({
          setHeaders: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        return next.handle(modifiedRequest).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.auth.logout();
            }

            return throwError(error);
          })
        );

        // FIN ELSE IF
      } else {
        //  INICIO ELSE

        const token = JSON.parse(localStorage.getItem("token"));

        const modifiedRequest = request.clone({
          setHeaders: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        });

        return next.handle(modifiedRequest).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.auth.logout();
            }

            return throwError(error);
          })
        );

        // FIN ELSE
      }
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.auth.logout();
        }

        return throwError(error);
      })
    );
  }

  private isValidRequestForInterceptor(requestUrl: string): boolean {
    const positionIndicator = "sec/";
    const position = requestUrl.indexOf(positionIndicator);
    if (position > 0) {
      const destination: string = requestUrl.substr(
        position + positionIndicator.length
      );
      for (const address of this.urlsToNotUse) {
        if (new RegExp(address).test(destination)) {
          return false;
        }
      }
    }
    return true;
  }
}
